import ModoRanking from './ModoRankingList';

export default ModoRanking;
